App.controller('HealthInsuranceWithPaymentsPlaceCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', function ($scope, $sce, $state, $http, packageService, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsuranceWithPayments_place';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Placówki medyczne';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.healthInsuranceWithPayments.start';
    $scope.$emit('link', $scope.link);
}]);
